import { useAppSelector } from 'hooks/redux/useRedux';

export default function useGetCurrentUser() {
    const user = useAppSelector(state => state.authenticationReducer.user);

    return user;
}
